import client from "api/client";


const _client = client.route("/content");

const content = {
	get: (payload) => _client.post("", payload),
	history: (payload) => _client.post("/history", payload),
	passHistory: (payload) => _client.post("/history/pass", payload),
	unlock: (payload) => _client.post("/unlock", payload),
	read: (payload) => _client.post("/read", payload),
	featured: () => _client.get("/featured"),
	top: (payload) => _client.post("/top", payload),
	last: () => _client.post("/last"),
	bookmarked: () => _client.get("/bookmarked"),
	setBookmark: (payload) => _client.post("/bookmark", payload)
};

const giftBase = "/gift";

const gift = {
	getInfo: (payload) => _client.post(giftBase + "/info", payload),
	buy: (payload) => _client.post(giftBase + "/buy", payload),
	getBuyInfo: (payload) => _client.post(giftBase + "/buy/info", payload),
	unlock: (payload) => _client.post(giftBase + "/unlock", payload),
	refund: (payload) => _client.post(giftBase + "/refund", payload)
};

export default { ...content, gift };